export default {
  SIGNUP: 'signup',
  CHAT: 'chat'
};



// WEBPACK FOOTER //
// ./src/constants/conciergeStates.js